import { render, staticRenderFns } from "./AddSchoolGatherPlace.vue?vue&type=template&id=5cb59931&scoped=true&"
import script from "./AddSchoolGatherPlace.vue?vue&type=script&lang=js&"
export * from "./AddSchoolGatherPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb59931",
  null
  
)

export default component.exports